var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBetbookProfileCheckIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon nui-betbook-profile-check-icon",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.69.751a.749.749 0 011.059-.06c.281.25.33.664.129.97l-.068.088-10.25 11.5a.75.75 0 01-1.053.066l-.078-.08-4.25-5a.75.75 0 011.065-1.05l.077.08 3.692 4.342L14.69.751z"
  })));
}

export default SvgBetbookProfileCheckIconSv;